import { Loader } from '@any-ui-react/core';
import { useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { useGoogleOfflineOAuthCallbackQuery } from '@/common/graphql';
import { AUTH_STATE_KEY, getStorageItem } from '@/common/utils';

interface Props {
  redirectUri: string;
  redirectTo: string;
}

export const GoogleOfflineOAuthCallback = ({ redirectUri, redirectTo }: Props) => {
  const navigate = useNavigate();
  const authState = getStorageItem(AUTH_STATE_KEY) ?? '';

  const { search } = useLocation();
  const query = useMemo(() => new URLSearchParams(search), [search]);
  const code = query.get('code') ?? '';
  const isValidState = authState === query.get('state');

  const { data, error } = useGoogleOfflineOAuthCallbackQuery({
    variables: { code, redirectUri },
    skip: !authState || !code || !isValidState,
    onCompleted: () => {
      navigate(redirectTo);
    },
    onError: () => {
      navigate(redirectTo);
    },
  });

  useEffect(() => {
    if (data) navigate(redirectTo);
  }, [data, navigate, redirectTo]);

  useEffect(() => {
    if (!error) return;
    navigate(redirectTo);
  }, [error, navigate, redirectTo]);

  return <Loader />;
};
